export default __webpack_public_path__ + "static/media/key.c49b4bbe.svg";